import { makeStyles, Theme } from "@material-ui/core";
import { createStyles } from "@material-ui/styles";

export const useReceiverStyles = makeStyles((theme: Theme) => ({
  icon: {
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(2),
  },
  containerInfo: {
    fontWeight: 500,
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      fontWeight: 500,
      display: "flex",
      paddingBottom: "10px",
    },
  },
  numbers: {
    color: theme.palette.primary.main,
  },
  info: {
    color: "#707070",
    marginLeft: 6,
  },
  showDesign: {
    padding: "54px 54px",
    height: 400,
    marginTop: -20,
    [theme.breakpoints.down("xs")]: {
      padding: "40px 1px",
      marginLeft: -27,
    },
  },
}));

export const useReceiverListStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      height: 400,
      position: "relative",
      display: "flex",
      justifyContent: "space-between",
      paddingTop: "1.4%",
    },
    topListReceiver: {
      display: "flex",
      [theme.breakpoints.down("xs")]: { display: "grid", padding: "0px 21px 6px 0px" },
    },
    iconAdress: {
      display: "flex",
      marginBottom: "20px",
      padding: "3px",
      [theme.breakpoints.down("xs")]: { width: "185px" },
    },
    caisse: {
      width: 40,
      height: 40,
      display: "flex",
      justifyItems: "center",
      justifyContent: "center",
      opacity: 0.7,
      borderRadius: 12,
      marginRight: 20.5,
    },
    name: {
      fontSize: 12,
      fontWeight: 500,
      color: "#707070",
    },
    type: {
      fontSize: 18,
      fontWeight: 800,
      color: "#399ebf",
    },
    nameContent: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      height: 48,
      marginBottom: 5,
    },
    detail: {
      height: 58,
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      justifyContent: "space-between",
      [theme.breakpoints.down("xs")]: { marginTop: -70 },
    },
    time: {
      color: "#707070",
      fontSize: 14,
      marginLeft: 20.5,
    },
    number: {
      color: "#707070",
      fontSize: 14,
      marginLeft: 20.5,
    },
    bloc: {
      display: "flex",
    },
    icon: {
      marginLeft: 2,
    },

    fixedTop: {
      display: "flex",
    },
    search: {
      "&.MuiInputBase-input ": {
        height: "1.1rem",
        [theme.breakpoints.down("xs")]: { width: "244px" },
      },
      marginLeft: "auto",
    },
    table: {
      height: 340,
      marginTop: "1.5rem",
    },
    fabs: {
      position: "absolute",
      right: 20,
      bottom: 5,
    },
    button: {
      "&.MuiButton-root": {
        width: "160px",
        marginLeft: "20px",
        height: "52px",
        [theme.breakpoints.down("xs")]: { marginRight: -180, marginBottom: "16px" },
      },
    },
  })
);
